/* tslint:disable */
/* eslint-disable */
/**
 * WAG TP Request API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WAGTPResponseBody
 */
export interface WAGTPResponseBody {
    /**
     * 
     * @type {number}
     * @memberof WAGTPResponseBody
     */
    returnCode: number;
    /**
     * 
     * @type {string}
     * @memberof WAGTPResponseBody
     */
    returnMessage: string;
}

export function WAGTPResponseBodyFromJSON(json: any): WAGTPResponseBody {
    return WAGTPResponseBodyFromJSONTyped(json, false);
}

export function WAGTPResponseBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): WAGTPResponseBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'returnCode': json['returnCode'],
        'returnMessage': json['returnMessage'],
    };
}

export function WAGTPResponseBodyToJSON(value?: WAGTPResponseBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'returnCode': value.returnCode,
        'returnMessage': value.returnMessage,
    };
}


